import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {Errors} from '../../../utilities/errors';
import {CONTACT_START, CONTACT_SUCCESS, CONTACT_FAIL, CONTACT_RESET} from './constants';
import {ContactStartAction, ContactSuccessAction, ContactFailAction, ContactResetAction} from './types';
import {contactRequest} from './repository';
import {ContactRequest} from '../../../models/requests/contact.request';

const contactStartAction = (): ContactStartAction => {
  return {
    type: CONTACT_START,
  };
};
const contactSuccessAction = (payload: boolean): ContactSuccessAction => {
  return {
    type: CONTACT_SUCCESS,
    payload: payload,
  };
};
const contactFailAction = (error: ErrorDto): ContactFailAction => {
  return {
    type: CONTACT_FAIL,
    error: error,
  };
};
const contactResetAction = (): ContactResetAction => {
  return {
    type: CONTACT_RESET,
  };
};

export const contact = (request: ContactRequest) => async (dispatch: Dispatch) => {
  try {
    dispatch(contactStartAction());
    await contactRequest(request);
    dispatch(contactSuccessAction(true));
  } catch (error) {
    dispatch(contactFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const contactReset = () => (dispatch: Dispatch) => {
  dispatch(contactResetAction());
};
